module.exports = __webpack_public_path__ + "img/profile-picture.1382ba0.jpg";